import(/* webpackMode: "eager" */ "/Users/ejazkhan/Documents/sealRepos/seal-business/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/ejazkhan/Documents/sealRepos/seal-business/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ejazkhan/Documents/sealRepos/seal-business/src/app/components/ScrollRevealInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ejazkhan/Documents/sealRepos/seal-business/src/app/safety/components/SafetyCommunity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ejazkhan/Documents/sealRepos/seal-business/src/components/Header.tsx");
